import React from 'react';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  /** Size variant: 'small' (20px), 'medium' (40px), 'large' (60px) */
  size?: 'small' | 'medium' | 'large';
  /** Optional message to display below the spinner */
  message?: string;
  /** If true, centers the spinner in its container with padding */
  fullPage?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  message,
  fullPage = false,
}) => {
  const spinnerClass = `loading-spinner loading-spinner--${size}`;

  if (fullPage) {
    return (
      <div className="loading-spinner-container">
        <div className={spinnerClass} />
        {message && <p className="loading-spinner-message">{message}</p>}
      </div>
    );
  }

  return (
    <span className="loading-spinner-inline">
      <span className={spinnerClass} />
      {message && <span className="loading-spinner-message">{message}</span>}
    </span>
  );
};

export default LoadingSpinner;
